import React, { useContext } from 'react';

import { AppBar, Tab, Tabs } from '@material-ui/core';
import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../../store';
import { initialEventTemplate } from '../../../../../store/admin/events/store';

import Button from '../../../../../components/Button';
import { getActiveTab } from './Utils/getActiveTab';
import { getTabRelativeURI } from './Utils/getTabRelativeURI';
import { IEventWizardNavigator, tabsToScroll, BASE_TAB_WIDTH } from './EventWizardNavigator';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

export const EventWizardNavigatorDesktop = (props: IEventWizardNavigator) => {
  const { currentPage, currentRound } = props;

  const {
    actions: { notifications },
    adminEvents
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const event = adminEvents[Number(eventId)] || initialEventTemplate;
  const numOfRounds = event.rounds ? event.rounds.length : 0;
  const numOfTabs = numOfRounds + 2;
  const tabsVariant = numOfRounds + 2 > tabsToScroll() ? 'scrollable' : 'fullWidth';
  const centered = tabsVariant !== 'scrollable';
  const activeTab = getActiveTab(currentPage, event.rounds || [], currentRound);

  const setTab = (_: any, tabToSet: number) => {
    if (!event.rounds) {
      return;
    }

    const roundsIds = event.rounds.map(round => round.id);

    const whereTo = getTabRelativeURI(
      roundsIds,
      currentPage,
      eventId,
      clubId,
      currentRound,
      tabToSet
    );

    if (whereTo) {
      navigate(whereTo);
    }
  };

  const goToEvents = async () => {
    await notifications.push({
      status: 'unread',
      text: 'The event settings have been saved',
      type: 'success'
    });
    navigate(`/staff/club/${clubId}/events`);
  };

  return (
    <div className="admin-wrapper event-wizard-navigator">
      <div className={`event-wizard-tab-menu-container`}>
        <AppBar
          className="event-wizard-tab-menu"
          position="static"
          style={{ maxWidth: `calc(var(--px) * ${numOfTabs * BASE_TAB_WIDTH})` }}
        >
          <Button
            color="primary"
            onClick={goToEvents}
            className="all-events-button override"
            variant="text"
          >
            <LeftArrow className="left-arrow-icon" />
            ALL EVENTS
          </Button>

          <Tabs
            centered={centered}
            classes={{
              flexContainer: 'tabs-container override',
              indicator: 'tab-indicator'
            }}
            onChange={setTab}
            scrollButtons="auto"
            value={activeTab}
            variant={tabsVariant}
          >
            <Tab
              classes={{ wrapper: 'tab-label' }}
              className="event-wizard-tab override"
              label="EVENT SETUP"
            />
            {(event.rounds && event.status === 'published' ? event.rounds : []).map(
              (round, index) => (
                <Tab
                  classes={{ wrapper: 'tab-label' }}
                  className="event-wizard-tab override"
                  key={`tab-round-${round.id}`}
                  label={`Round ${index + 1}`}
                />
              )
            )}
            <Tab
              classes={{ wrapper: 'tab-label' }}
              className="event-wizard-tab override"
              label="COMPLETE EVENT"
            />
          </Tabs>
        </AppBar>
      </div>
    </div>
  );
};
